import { Component, Input } from '@angular/core';
import { WhiskeyItem } from '../../menu.model'

@Component({
  selector: 'reserve',
  templateUrl: './reserve.component.html',
  styleUrls: ['./reserve.component.scss']
})
export class ReserveComponent {

    @Input() whiskeyList: Array<WhiskeyItem> = [];
    @Input() activeSection: string | undefined;

    constructor() { }
}
